import { Tab as MuiTab, TabProps } from '@mui/material';
import React from 'react';

export const Tab: React.FC<TabProps> = ({
  label,
  sx,
  ...props
}): JSX.Element => {
  return (
    <MuiTab
      {...props}
      label={label}
      sx={{
        textTransform: 'none',
        fontWeight: 'bold',
        p: '1em',
        minHeight: '1.5em',
        flexShrink: 0,
        maxWidth: 'none',
        ...sx,
      }}
    />
  );
};
